module.exports = __webpack_public_path__ + "static/favicon-b4cd30b96bf34ee264909191b5f8ee53.ico";